import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Panel } from "@/components/Panel";
import { Schedule } from "@/components/Schedule";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-[var(--cream)]">
      <Header />
      <main>
        <Hero />
        <About />
        <Panel />
        <Schedule />
      </main>
      <Footer />
    </div>
  );
}

export default App;
